"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _OrdinalFrame = require("./OrdinalFrame");

var _OrdinalFrame2 = _interopRequireDefault(_OrdinalFrame);

var _SparkFrame = require("./SparkFrame");

var _SparkFrame2 = _interopRequireDefault(_SparkFrame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _SparkFrame2.default)(_OrdinalFrame2.default, _SparkFrame.ordinalFrameDefaults);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/semiotic/lib/SparkOrdinalFrame.js
// module id = 1368
// module chunks = 0